"use client"

// Thin "use client" wrapper around gt-react's ClientProvider.
// gt-react/client doesn't include a "use client" directive in its bundle,
// so importing it in a server component fails. This wrapper establishes
// the client boundary needed for SyncGTProvider (a sync RSC).

import { ClientProvider } from "gt-react/client"

export default function GTClientWrapper(props: any) {
    return <ClientProvider {...props} />
}
